const MakeswiftComponentType = {
  Box: "./components/Box/index.js",
  Button: "./components/Button/index.js",
  Carousel: "./components/Carousel/index.js",
  Countdown: "./components/Countdown/index.js",
  Divider: "./components/Divider/index.js",
  Embed: "./components/Embed/index.js",
  Form: "./components/Form/index.js",
  Image: "./components/Image/index.js",
  Navigation: "./components/Navigation/index.js",
  Root: "./components/Root/index.js",
  Slot: "makeswift::components::slot::v1",
  SocialLinks: "./components/SocialLinks/index.js",
  Text: "./components/Text/index.js",
  Video: "./components/Video/index.js"
};
export {
  MakeswiftComponentType
};
//# sourceMappingURL=constants.js.map